import { render, staticRenderFns } from "./tagEditModal.vue?vue&type=template&id=9c488378&scoped=true"
import script from "./tagEditModal.vue?vue&type=script&lang=js"
export * from "./tagEditModal.vue?vue&type=script&lang=js"
import style0 from "./tagEditModal.vue?vue&type=style&index=0&id=9c488378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c488378",
  null
  
)

export default component.exports